import React from 'react';
import { contactInfo } from '../utils/mockData';
import { Phone, Mail, MapPin } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-50 text-blue-900 rounded-full text-sm font-semibold mb-4">
            Get in Touch
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Contact Us
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ready to start your surveying project? Reach out to our team
          </p>
        </div>

        {/* Contact Information */}
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {/* Phone */}
            <div className="flex flex-col items-center text-center p-8 bg-gray-50 rounded-xl hover:bg-blue-50 transition-colors group cursor-pointer">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-blue-700 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform mb-4">
                <Phone className="w-8 h-8 text-white" />
              </div>
              <div className="text-sm font-semibold text-gray-600 mb-2">Phone</div>
              <a href={`tel:${contactInfo.phone}`} className="text-xl font-bold text-gray-900 hover:text-blue-900 transition-colors">
                {contactInfo.phone}
              </a>
            </div>

            {/* Email */}
            <div className="flex flex-col items-center text-center p-8 bg-gray-50 rounded-xl hover:bg-blue-50 transition-colors group cursor-pointer">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-blue-700 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform mb-4">
                <Mail className="w-8 h-8 text-white" />
              </div>
              <div className="text-sm font-semibold text-gray-600 mb-2">Email</div>
              <a href={`mailto:${contactInfo.email}`} className="text-xl font-bold text-gray-900 hover:text-blue-900 transition-colors break-all">
                {contactInfo.email}
              </a>
            </div>

            {/* Address */}
            <div className="flex flex-col items-center text-center p-8 bg-gray-50 rounded-xl hover:bg-blue-50 transition-colors group cursor-pointer">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-blue-700 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform mb-4">
                <MapPin className="w-8 h-8 text-white" />
              </div>
              <div className="text-sm font-semibold text-gray-600 mb-2">Location</div>
              <div className="text-lg font-bold text-gray-900">
                {contactInfo.address}
              </div>
            </div>
          </div>

          {/* Contact Email CTA */}
          <div className="mt-12 text-center p-8 bg-gradient-to-br from-blue-900 to-blue-800 rounded-2xl">
            <h3 className="text-3xl font-bold text-white mb-4">
              Contact us at
            </h3>
            <a 
              href={`mailto:${contactInfo.email}`}
              className="text-4xl font-bold text-white hover:text-blue-200 transition-colors inline-block"
            >
              {contactInfo.email}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
